//** Imports */
import mixitup from './mixitup.min.js';
import mixitupMultifilter from './mixitup-multifilter.js';

//** Mixitup */
mixitup.use(mixitupMultifilter);
const relatedArticlesEl = document.querySelector(".related-articles")

if (document.body.contains(relatedArticlesEl)) {
  const mixer = mixitup(relatedArticlesEl, {
    multifilter: {
      enable: true
    },
    animation: {
      queue: false
    }
  })
}

//** Header | Menu Toggle */
const navToggle = document.querySelector("#nav-toggle");
navToggle.addEventListener("click", function (e) {
  var navLayout = document.querySelector(".mobile-nav");
  navToggle.classList.toggle("nav-toggle--active");
  navLayout.classList.toggle("mobile-nav--open");
});

//** Article Block | Amount of articles */

if (document.body.contains(relatedArticlesEl)) {
  const articleBlock = document.querySelector(".article-block")
  const articleSelects = document.querySelectorAll('.article-block__select')

  articleSelects.forEach((select) => {
    select.addEventListener("change", () => {
      articleBlock.classList.remove("articles--5")
      articleBlock.classList.remove("articles--9")
      articleBlock.classList.remove("articles--11")
    })
  })

  // - Only works in Firefox for some reason.
  // - Chrome, Edge & Safari needs something else.

  /* var optionsEl = document.querySelectorAll(".article-option")
    optionsEl.forEach((option) => {
    option.addEventListener("mouseup", (e) => {
      
      articleBlock.classList.remove("articles--5")
       articleBlock.classList.remove("articles--9")
      articleBlock.classList.remove("articles--11")
    })
 })*/
}


